import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/seo-data";

const trustImages = [
  {
    name: "Aktualizowane poradniki",
    url: categories[0].url,
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20notebook%20and%20pen%20on%20warm%20cream%20desk%2C%20minimalist%20workspace%2C%20soft%20natural%20light%2C%20clean%20lifestyle%20aesthetic%2C%20editorial%20photography%2C%20organized%20composition&width=400&height=300&seq=trust-img-01-v2&orientation=landscape",
  },
  {
    name: "Szczegółowe porównania",
    url: categories[1].url,
    image:
      "https://readdy.ai/api/search-image?query=Two%20stylish%20products%20side%20by%20side%20on%20warm%20beige%20surface%2C%20minimalist%20comparison%20concept%2C%20soft%20natural%20daylight%2C%20clean%20editorial%20style%2C%20balanced%20composition&width=400&height=300&seq=trust-img-02-v2&orientation=landscape",
  },
  {
    name: "Instrukcje krok po kroku",
    url: categories[2].url,
    image:
      "https://readdy.ai/api/search-image?query=Step%20by%20step%20guide%20concept%20with%20stylish%20stationery%20on%20cream%20background%2C%20minimalist%20lifestyle%2C%20soft%20lighting%2C%20clean%20aesthetic%2C%20editorial%20photography%2C%20organized%20layout&width=400&height=300&seq=trust-img-03-v2&orientation=landscape",
  },
  {
    name: "Informacje o bezpieczeństwie",
    url: categories[3].url,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20security%20shield%20concept%20with%20elegant%20product%20on%20warm%20neutral%20backdrop%2C%20minimalist%20design%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20aesthetic%2C%20trust%20symbolism&width=400&height=300&seq=trust-img-04-v2&orientation=landscape",
  },
  {
    name: "Regularne aktualizacje",
    url: categories[4].url,
    image:
      "https://readdy.ai/api/search-image?query=Fresh%20modern%20calendar%20and%20stylish%20product%20on%20cream%20surface%2C%20minimalist%20update%20concept%2C%20soft%20natural%20light%2C%20clean%20editorial%20photography%2C%20organized%20composition&width=400&height=300&seq=trust-img-05-v2&orientation=landscape",
  },
];

export default function TrustSection() {
  const { t } = useTranslation("home");

  return (
    <section className="relative bg-background-50 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-4xl mx-auto text-center">
        {/* Label */}
        <div className="inline-block border border-foreground-300 rounded-full px-5 py-2 mb-8">
          <span className="text-sm text-foreground-600 font-medium">{t("whatIsLabel")}</span>
        </div>

        <h2 className="text-3xl md:text-5xl font-heading font-light text-foreground-950 leading-[1.3]">
          {t("whatIsTitle1")}
          <br />
          {t("whatIsTitle2")}
          <br />
          {t("whatIsTitle3")}
        </h2>

        {/* Trust badges with images */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
          {trustImages.map((item, i) => (
            <a
              key={i}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 rounded-xl overflow-hidden hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="h-28 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center justify-center gap-2 px-3 py-3">
                <i className="ri-check-line text-primary-500 text-lg flex-shrink-0"></i>
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">{item.name}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}